export const DynamicAsideMenuConfig = {
  items: [
    // {
    //   title: 'Profile',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   // svg: './assets/media/svg/icons/System/Profile.svg',
    //   svg: './assets/img/Icons/Profile.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.PROFILE',
    //   page: '/portal/profile',
    //   role:'Profile',
    // },
    // {
    //   title: 'Labs',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Labs.svg',
    //   svg: './assets/img/Icons/LaboratoryResults.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.LABS',
    //   page: '/portal/labs/search',
    //   role:'Labs',
    // },
    // {
    //   title: 'Radiology',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Radiology.svg',
    //   svg: './assets/img/Icons/RadiologyResults.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.RADIOLOGY',
    //   page: '/portal/radiologies/search',
    //   role:'Radiology',
    // },
    // {
    //   title: 'Appointments',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Appointments.svg',
    //   svg: './assets/img/Icons/MyAppointments.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.APPOINTMENTS',
    //   page: '/portal/appointments/search',
    //   role:'Appointments',
    // },
    
    // {
    //   title: 'PatientVisits',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Visits.svg',
    //   svg: './assets/img/Icons/MyVisits.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.PATIENTVISITS',
    //   page: '/portal/patientvisits/search',
    //   role:'PatientVisits',
    // },
    // {
    //   title: 'Invoices',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Invoices.svg',
    //   svg: './assets/img/Icons/Invoices.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.INVOICES',
    //   page: '/portal/invoices/search',
    //   role:'Invoices',
    // },
    // {
    //   title: 'Payments',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Approval.svg',
    //   svg: './assets/img/Icons/Invoices.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.PAYMENTS',
    //   page: '/portal/payments/search',
    //   role:'Payments',
    // },
    // {
    //   title: 'Approvals',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Approval.svg',
    //   svg: './assets/img/Icons/InsuranceApprovals.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.APPROVALS',
    //   page: '/portal/approvals/search',
    //   role:'Approvals',
    // },
    
    // {
    //   title: 'Family',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Family.svg',
    //   svg: './assets/img/Icons/Family.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.FAMILY',
    //   page: '/portal/family/addnewmember',
    //   role:'Family',
    // },
    // {
    //   title: 'Birth requests',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //    svg: './assets/media/svg/icons/System/BirthRequest.svg',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.BIRTHREQUESTS',
    //   page: '/portal/birthrequests/search',
    //   role:'BirthRequests',
    // },
    // {
    //   title: 'SickLeave Requests',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/SickLeave.svg',
    //   svg: './assets/img/Icons/SickLeave.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.SICKLEAVEREQUEST',
    //   page: '/portal/sickleaverequests/search',
    //   role:'SickLeaveRequests',
    // },
    // {
    //   title: 'Medical Report Requests',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Medical.svg',
    //   svg: './assets/img/Icons/MedicalReport.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.MEDICALREPORTREQUEST',
    //   page: '/portal/medicalReportrequests/search',
    //   role:'MedicalReportRequests',
    // },
    // {
    //   title: 'Outside Test',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   svg: './assets/img/Icons/MedicalReport.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.OUTSIDETEST',
    //   page: '/portal/outsideTest/search',
    //   role:'OutsideTest',
    // },
    // {
    //   title: 'SwitchFamily',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //    svg: './assets/media/svg/icons/System/SwitchFamily.svg',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.SwitchFamily',
    //   page: '/portal/family/switch',
    //   role:'Patient',
    // },
    // {
    //   title: 'DoctorVisits',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Visits.svg',
    //   svg: './assets/img/Icons/MyVisits.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.VISITS',
    //   page: '/portal/visits/search',
    //   role:'DoctorVisits',
    // },
    // {
    //   title: 'Birth requests',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //    svg: './assets/media/svg/icons/System/BirthRequest.svg',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.BIRTHREQUESTS',
    //   page: '/portal/birthrequestsstaff/search',
    //   role:'BirthRequestsStaff',
    // },
    // {
    //   title: 'SickLeave requests',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   // svg: './assets/media/svg/icons/System/SickLeave.svg',
    //   svg: './assets/img/Icons/SickLeave.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.SICKLEAVEREQUEST',
    //   page: '/portal/sickleaverequests/search',
    //   role:'SickLeaveRequestsStaff',
    // },
    // {
    //   title: 'Medical Report Requests',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Medical.svg',
    //   svg: './assets/img/Icons/MedicalReport.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.MEDICALREPORTREQUEST',
    //   page: '/portal/medicalReportrequests/search',
    //   role:'MedicalReportRequestsStaff',
    // },
    // {
    //   title: 'Complaints-Suggestions',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Medical.svg',
    //   svg: './assets/img/Icons/MedicalReport.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.complaintsandsuggestions',
    //   page: '/portal/complaintsandsuggestions/search',
    //   role:'ComplaintSuggestions',
    // },
    // {
    //   title: 'Offer-Requests',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   //  svg: './assets/media/svg/icons/System/Medical.svg',
    //   svg: './assets/img/Icons/SickLeave.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.offerrequest',
    //   page: '/portal/offerrequests/search',
    //   role:'OfferRequest',
    // },
    {
      title: 'News',
      bullet: 'dot',
      icon: 'icofont-patient-bed',
      //  svg: './assets/media/svg/icons/System/Medical.svg',
      svg: './assets/img/news.png',
      root: true,
      permission: 'accessToTeamsModule',
      translate: 'MENU.BLOG',
      page: '/portal/news/search',
      role:'News',
    },
     {
      title: 'Board',
      bullet: 'dot',
      icon: 'icofont-patient-bed',
      //  svg: './assets/media/svg/icons/System/Medical.svg',
      svg: './assets/img/board.png',
      root: true,
      permission: 'accessToTeamsModule',
      translate: 'MENU.BOARD',
      page: '/portal/board/search',
      role:'Board',
    },
    // {
    //   title: 'Settings',
    //   bullet: 'dot',
    //   icon: 'icofont-patient-bed',
    //   // svg: './assets/media/svg/icons/System/Settings.svg',
    //   svg: './assets/img/Icons/Settings.png',
    //   root: true,
    //   permission: 'accessToTeamsModule',
    //   translate: 'MENU.SETTINGS',
    //   page: '/portal/settings',
    //   role:'Settings',
    // },
    
  ]
};
